import apiClient from '../apiClient';
import { GET_SERVICE_PRICE_TYPE_URL } from '../apiUrl';

const getServicePriceTypeApi = type => {
  return apiClient.get(GET_SERVICE_PRICE_TYPE_URL(type));
};

export default getServicePriceTypeApi;
